import { Bus } from 'baconjs'

export const saveProfile = new Bus()
